import React, { Fragment, useState } from "react";
import TwoDayDeliveryTruckIcon from "../../../public/next-public/common/icons/two-day-delivery-truck-icon.svg";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import styles from "./twoDayDeliveryBadge.module.scss";

let timeout: NodeJS.Timeout;

interface TwoDayDeliveryBadgeProps {
  size?: "1x" | "2x" | "4x" | "8x";
  visible?: boolean;
  isVendorPicker?: boolean;
  isConfirmationPage?: boolean;
  tooltipPlacement?: "top" | "bottom";
}

const TwoDayDeliveryBadge: React.FC<TwoDayDeliveryBadgeProps> = ({
  size = "1x",
  visible = true,
  isVendorPicker = false,
  isConfirmationPage = false,
  tooltipPlacement = "top",
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const toggleTooltip = () => {
    clearTimeout(timeout);
    setShowTooltip((t) => !t);
  };

  const displayTooltip = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setShowTooltip(true);
    }, 500);
  };

  const hideTooltip = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setShowTooltip(false);
    }, 200);
  };

  if (!visible) return null;

  const title = "Free 2-Day Delivery available on qualifying products from this seller. Minimums may apply.";
  const OverlayComponent = isVendorPicker || isConfirmationPage ? Fragment : OverlayTrigger;

  return (
    <OverlayComponent show={showTooltip} placement={tooltipPlacement} overlay={<Tooltip>{title}</Tooltip>}>
      <div
        className={`${styles.TwoDayDeliveryUIBadgeComponent} ${
          !isVendorPicker ? styles.adjustAlignment : ""
        } ${styles[`size-${size}`]}`}
        onClick={toggleTooltip}
        onMouseEnter={displayTooltip}
        onMouseLeave={hideTooltip}
      >
        <span className={styles.icon}>
          <TwoDayDeliveryTruckIcon />
        </span>
        <span className={styles.text}>Free 2 Day Delivery</span>
      </div>
    </OverlayComponent>
  );
};

export default TwoDayDeliveryBadge;
